import styled from 'styled-components';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(Accordion) `
  && {
    box-shadow: none;
    margin: 0;

    &.Mui-expanded {
      margin: 0;
    }
  }
`;
export const Summary = styled(AccordionSummary) `
  &&& {
    flex-direction: row-reverse;
    gap: ${theme.spacing.md};
    margin: 0;
    min-height: 0;
    padding: 0;

    .MuiAccordionSummary-content {
      margin: 0;
    }

    .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(90deg);
    }
  }
`;
export const Details = styled(AccordionDetails) `
  && {
    padding: 0;
  }
`;
